import styled from 'styled-components';
import Typography from '../../typography/Typography';
export const SuccesText = styled(Typography) `
  color: ${({ theme }) => theme.colors.text.success};
  height: 1.8rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
`;
export const FailedText = styled(Typography) `
  color: ${({ theme }) => theme.colors.text.critical};
  height: 1.8rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
`;
export const Container = styled.div `
  background-color: ${({ theme }) => theme.colors.surface.default};
  padding: 0.8rem 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  width: fit-content;
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=styles.js.map